module.exports = __webpack_public_path__ + "static/media/bonding-child-family-care-svgrepo-com.0706a647.svg";